import React from 'react';
import PropTypes from 'prop-types';
import HoverComponent from './hover-component';

export default class MoveComponent extends HoverComponent {

    static propTypes = {
        disableMouseMoveListeners: PropTypes.bool,
    };

    static defaultProps = {
        disableMouseMoveListeners: false
    };

    constructor(props) {
        super(props);

        this.lastMousePosition = null;

        this.state = _.assign(this.state, {
            isMoving: false
        });

        this._bind('_addWindowListeners', '_removeWindowListeners', 'getStartPosition', 'setStartPosition', 'setPosition',
            'getMousePositionDelta', 'onMouseDown', 'onMouseMove', 'onMouseUp');
    }

    componentDidMount() {
        super.componentDidMount();
        this.setStartPosition();
        if (!this.props.disableMouseMoveListeners && this.componentEl) {
            this.componentEl.addEventListener("mousedown", this.onMouseDown);
            this.componentEl.addEventListener("mouseup", this.onMouseUp);
        }
    }

    componentWillUnmount() {
        if (!this.props.disableMouseMoveListeners && this.componentEl) {
            this.componentEl.removeEventListener("mousedown", this.onMouseDown);
            this.componentEl.removeEventListener("mouseup", this.onMouseUp);
        }

        this._removeWindowListeners();
    }

    setStartPosition(position) {
        if (position) {
            this.startPosition = {
                x: position.x,
                y: position.y
            }
        } else {
            const { offsetLeft, offsetTop } = this.componentEl;

            this.startPosition = {
                x: offsetLeft ? offsetLeft : 0,
                y: offsetTop ? offsetTop : 0
            }
        }
    }

    getStartPosition() {
        return this.startPosition;
    }

    _addWindowListeners() {
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", this.onMouseUp);
    }

    _removeWindowListeners() {
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onMouseUp);
    }

    setLastMousePosition(e) {
        this.lastMousePosition = {x: e.clientX, y: e.clientY};
    }

    getLastMousePosition() {
        return this.lastMousePosition;
    }

    setPosition(x,y) {
        this.componentEl.style.setProperty("left", x + "px");
        this.componentEl.style.setProperty("top", y + "px");
    }

    getMousePositionDelta(e) {
        return {
            dx: e.clientX - this.lastMousePosition.x,
            dy: e.clientY - this.lastMousePosition.y
        };
    }

    onMouseDown(e, callback) {
        e.stopPropagation();
        e.preventDefault();

        this.setLastMousePosition(e);
        this.setStartPosition();

        this._addWindowListeners();

        this.setState({
            isMoving: true
        }, ()=>{if(callback)callback()});
    }

    onMouseMove(e, callback) {
        const { x, y } = this.getStartPosition();
        const { dx, dy } = this.getMousePositionDelta(e);
        this.setPosition(x + dx, y + dy);

        if(callback) callback(x, y, dx, dy)
    }

    onMouseUp(e, callback) {
        this._removeWindowListeners();

        this.setState({
            isMoving: false
        }, ()=>{if(callback)callback()});
    }
}